<div *ngIf="active" class="bar-loader" [class.full-screen]="fullScreen"><div class="loader"></div></div>
